module.exports = __webpack_public_path__ + "media/1alB-g-gah.9722e740.mp3";